import { render, staticRenderFns } from "./CategoryDescription.vue?vue&type=template&id=08e5ec18&scoped=true&"
import script from "./CategoryDescription.vue?vue&type=script&lang=ts&"
export * from "./CategoryDescription.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDescription.vue?vue&type=style&index=0&id=08e5ec18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5ec18",
  null
  
)

export default component.exports